import { useState, useEffect } from 'react';

export default function FloatingCallButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <a
      href="tel:801-706-1610"
      className="fixed bottom-6 right-6 z-40 bg-amber-600 text-white w-16 h-16 rounded-full shadow-2xl hover:bg-amber-700 transition-all hover:scale-110 flex items-center justify-center group"
      aria-label="Call A-One Solid Surfacing"
    >
      <i className="ri-phone-line text-2xl animate-pulse"></i>
      <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity shadow-xl">
        Call Now: 801-706-1610
      </span>
    </a>
  );
}